import React, { useState } from 'react';

import { Button, DotProgression, Stack, Text } from 'shell/components';

const DotProgressionDemo = () => {
    const [activeStepIndex, setActiveStepIndex] = useState(0);

    return (
        <>
            <Text variant={'sh1'}>DotProgression</Text>
            <DotProgression activeStepIndex={activeStepIndex} numSteps={5} />
            <Stack direction={'row'} spacing={4}>
                <Button disabled={activeStepIndex === 0} onClick={() => setActiveStepIndex((current) => current - 1)}>
                    Back
                </Button>
                <Button disabled={activeStepIndex === 4} onClick={() => setActiveStepIndex((current) => current + 1)}>
                    Next
                </Button>
            </Stack>
        </>
    );
};

export default DotProgressionDemo;
